import { render, staticRenderFns } from "./CatalogProducts.vue?vue&type=template&id=0be8f4ae&"
import script from "./CatalogProducts.vue?vue&type=script&lang=js&"
export * from "./CatalogProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports